<!-- 投放数据看板 -->
<template>
	<div key="">
		<div id="" :style="{'width':table_scroll_width + 'px',}">
			
		
		<div :style="{'width':filter_box_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
			<!-- 标题 -->
			<div class="page-title">投放数据看板</div>
			
			<!-- 筛选条件 -->
			<div style="margin: 10px 0 0;">
				<div class="class-title">筛选条件</div>
				<div style="display: flex;align-items: center;flex-wrap: wrap;font-size: 13px;">
					<!-- 2023-1-9日期范围改为后端控制，在用户列表设置 -->
					<!-- <div v-if="role_control.includes(1) || role_control.includes(3)" class="screen-box"> -->
					<div class="screen-box">
						<div class="screen-label">投放日期</div>
						<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
						:locale="locale" 
						:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
					</div>
					<!-- <div v-else class="screen-box">
						<div class="screen-label">投放日期</div>
						<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false" 
						:locale="locale" 
						:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" 
						:disabledDate="DateControl" />
					</div> -->
					
					<div v-if="Object.keys(filterData.op_id).length > 0" class="screen-box">
						<div class="screen-label">投手</div>
						<a-select
						    mode="multiple"
						    style="min-width: 180px"
						    placeholder="请选择投手"
						    @change="handleChangeA"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
						    <a-select-option v-for="(item,index) in filterData.op_id.list" :key="index" :value="item.key">
						      {{item.value}}
						    </a-select-option>
						</a-select>
					</div>
					
					<div v-if="filterData.hasOwnProperty('group') && Object.keys(filterData.group).length > 0" class="screen-box">
						<div class="screen-label">投放小组</div>
						<a-select
							mode="multiple" 
							style="min-width: 200px;"
							placeholder="请选择投放小组"
							@change="handleChangeT"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
							showSearch
						  >
							<a-select-option v-for="(item,index) in filterData.group.list" :key="item.id" :value="item.id">
							  {{item.group_name}}
							</a-select-option>
						</a-select>
					</div>
					
					
					<div class="screen-box">
						<div class="screen-label">投放作品</div>
						
						<!-- <moreSelect
						:placeholder="'请选择投放作品'"
						:select_mode="'multiple'"
						@handleChangeSelect="handleChangeB"
						></moreSelect> -->
						
						<putBookSelect ref="getPutBook" @handleChangeSelect="handleChangeB"></putBookSelect>
					</div>
					
					<div class="screen-box">
						<div class="screen-label">作品类型</div>
						<a-select default-value="全部" style="width: 120px" 
						 @change="handleChangeC" 
						 :getPopupContainer="getsPopupContainer">
							<a-select-option  v-for="(item,index) in filterData.book_type.list" :key="index" :value="item.key">
								{{item.value}}
							</a-select-option>
							  
						</a-select>
					</div>
					
					<div class="screen-box">
						<div class="screen-label">媒体平台</div>
						<a-select
						    mode="multiple"
						    style="min-width: 200px"
						    placeholder="请选择媒体平台"
						    @change="handleChangeD"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
						    <a-select-option v-for="(item,index) in filterPlatform" :key="index" :value="item.id">
						      {{item.platform_name}}
						    </a-select-option>
						</a-select>
						
					</div>
					
					<div class="screen-box">
						<div class="screen-label">媒体版位</div>
						<a-select
						    mode="multiple"
						    style="min-width: 200px"
						    placeholder="请选择媒体版位"
						    @change="handleChangeE"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
						    <a-select-option v-for="(item,index) in filterData.media_id.list" :key="index" :value="item.key">
						      {{item.value}}
						    </a-select-option>
						</a-select>
					</div>
					
					<div class="screen-box">
						<div class="screen-label">书城</div>
						<a-select
							mode="multiple"
							style="min-width: 200px"
							placeholder="请选择书城"
							@change="handleChangeF"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
							<a-select-option v-for="(item,index) in filterData.channel_id.list" :key="index" :value="item.key">
							  {{item.value}}
							</a-select-option>
						</a-select>
					</div>
					
					<div class="screen-box">
						<div class="screen-label">公众号</div>
						
						<moreSelect
						ref="getGzhSelect"
						:placeholder="'请选择公众号'"
						:select_mode="'multiple'"
						@handleChangeSelect="handleChangeGzh"
						></moreSelect>
						
					</div>
					
					<div class="screen-box">
						<div class="screen-label">小程序</div>
						
						<xcxSearchSelect ref="getXcxSelect" :s_width="'200px'" @handleChangeSelect="handleChangeXCX"></xcxSearchSelect>
					</div>
					
					<div class="screen-box">
						<div class="screen-label">数据录入状态</div>
						
						<a-select
							style="width: 180px"
							placeholder="请选择数据录入状态"
							@change="handleChangeL"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
							showSearch
							:value="r_has_record"
						  >
							<template v-if="filterData.hasOwnProperty('has_record') && Object.keys(filterData.has_record).length > 0">
								<a-select-option v-for="(item,index) in filterData.has_record.list || []" :key="item.key" :value="item.key">
								  {{item.name}}
								</a-select-option>
							</template>
						</a-select>
						
					</div>
				</div>
			</div>
			<!-- 汇总条件 -->
			<div style="margin: 10px 0 0;">
				<div class="class-title">汇总条件</div>
				<div style="display: flex;align-items: center;flex-wrap: wrap;">
					<div v-for="(item,index) in collectHeadLabel" :key="index">
						<div v-if="item.label === '投放日期'" style="display: flex;align-items: center;margin-right: 15px;">
							<a-checkbox @change="handleChangeHZ($event,index)" :checked='item.checked_status'>
								投放日期
							</a-checkbox>
							<a-select default-value="day" style="width: 100px" @change="handleChangeH">
								  <a-select-option v-for="(item,index) in filterData.time_type.list" :key="index" :value="item.key">
									{{item.value}}
								  </a-select-option>
							</a-select>
						</div>
						
						<div v-else id="">
							<a-checkbox :checked='item.checked_status' @change="handleChangeHZ($event,index)" style="margin-right: 5px;">
								{{item.label}}
							</a-checkbox>
						</div>
						
					</div>

				</div>
			</div>
			<!-- 数据项 -->
			<div style="margin: 20px 0 0;">
				<div class="class-title">数据项</div>
				<div style="display: flex;align-items: center;flex-wrap: wrap;">
					<a-checkbox v-for="(item,index) in tableThLabel" :key="index" @change="onChangeSJ($event,index)" :checked="item.checked_status" style="margin-right: 5px;">
						{{item.label}}
					</a-checkbox>
				</div>
			</div>
			
			<div style="margin-top: 20px;margin-bottom: 20px;">
				<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
				<a-button @click="exportButton" type="primary" icon="download">导出</a-button>
			</div>
		
			
		</div>
		</div>
		
		<div class="loading-box" v-show="search_button_loading">
			<a-spin size="large" />
		</div>
		
		<!-- 表格内容 -->
		<TableShow id="table-show-box" @table-th-click="tableThClick" :rableTitle="rableTitle" :tableShowData="tableShowData" :tableTotalData="tableTotalData" :table_scroll_width="table_scroll_width" :date_type_control="date_type_control"></TableShow>
		<!-- 分页 -->
		
		<!-- <div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 41px;">
			<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': filter_box_width - 60 + 'px',}">
				<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
			</div>
		</div> -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="filter_box_width-60"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { putDataMenu,putDataPlatform,putDataGetChargeSum, putDataExport } from '@/request/api'
import TableShow from '@/components/putDataTable/TableShow.vue'
import moreSelect from '@/components/selectCompont/moreSelect.vue'
import putBookSelect from './components/putBookSelect.vue'
import xcxSearchSelect from '@/components/selectCompont/xcxSearchSelect.vue'
export default {
	name: 'summary_',
	components: {
		TableShow,moreSelect,putBookSelect, xcxSearchSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2019-07-12',
			endTime: '2022-07-13',
			
			// 筛选条件部分
			filterData: {
				op_id:{},
				book_id:{},
				book_type:{},
				media_id:{},
				channel_id:{},
				gzh_id:{},
				time_type:{},
				group: {},
				
				has_record: {}, // 数据录入状态
			}, // 筛选条件数组
			filterPlatform: [{}], // 筛选条件的-媒体平台
			filter_box_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1600, // 被表格撑开的实际内容宽度
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_op_id:[], // 搜索条件：投手id
			r_put_book: [], // 搜索条件：书籍
			r_book_type: "", // 搜索条件：书籍类型，1=男频，2=女频，0是全部，全部的情况好像可以不发送
			r_platform_id: [], // 媒体平台
			r_media_id: [], // 媒体版位
			r_channel_id: [], //  书城
			r_gzh_id: [], // 公众号
			r_group_id: undefined, // 投放小组
			r_date_type: "day", // 默认是天
			r_has_record: undefined, // 数据录入状态
			r_appid: undefined, // 选择小程序
			
			// 汇总条件
			collectHeadLabel: [
				{label:"投放日期", checked_status: true, type:"date_key",},
				{label:"投手", checked_status: false, type:"op_id",},
				{label:"投放作品", checked_status: false, type:"put_book",},
				{label:"媒体平台", checked_status: false, type:"put_media.type",},
				{label:"媒体版位", checked_status: false, type:"media_id",},
				{label:"书城", checked_status: false, type:"put_data.channel_id",},
				{label:"公众号/点众渠道号", checked_status: false, type:"gzh_id",},
				{label:"投放小组", checked_status: false, type:"group_id",},
				{label:"小程序", checked_status: false, type:"appid",},
			], // 汇总条件
			// 数据项
			tableThLabel: [
				{label:"投放金额", checked_status: true, type:"put_money",},
				{label:"净投放金额(返点后)", checked_status: true, type:"used_money",},
				{label:"充值金额", checked_status: true, type:"total_charge_money",},
				{label:"分成金额",checked_status: true,type:"left_money",},
				{label:"总ROI",checked_status: true,type:"roi",},
				{label:"首日ROI",checked_status: true,type:"today_roi",},
				{label:"近7日ROI",checked_status: true,type:"recent_left_money",},
				{label:"粉丝数",checked_status: true,type:"sub_num",},
				{label:"粉丝成本",checked_status: true,type:"sub_num_price",},
				{label:"付费人数",checked_status: true,type:"pay_user_num",},
				{label:"付费成本",checked_status: true,type:"pay_cost",},
				{label:"当天付费人数",checked_status: true,type:"today_pay_user_num",},
				{label:"当天付费成本",checked_status: true,type:"today_pay_user_num_cost",},
				{label:"近7日分成roi",checked_status: true,type:"seven_roi",},
				{label:"近7日分成明细",checked_status: false,type:"seven_left_money",},
			], // 数据项的选择，对应表头显示的内容
			tableShowData: [], // 表格用来展示的数据
			tableTotalData: [], // 总计，表格第一行
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"投放日期",width:90, sort_status:0,type:"date_key",show_control: true,sort_:90,sticky_control: true, text_right: false,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"投手",width:90, sort_status:0,type:"op_name",show_control: false,sort_:89,sticky_control: true, text_right: false,},
				{title:"投放作品",width:100, sort_status:0,type:"book_name",show_control: false,sort_:88,sticky_control: true, text_right: false,},
				{title:"作品类型",width:90, sort_status:0,type:"book_type",show_control: false,sort_:87,sticky_control: true, text_right: false,},
				{title:"媒体平台",width:90, sort_status:0,type:"platform_name",show_control: false,sort_:86,sticky_control: true, text_right: false,},
				{title:"媒体版位",width:90, sort_status:0,type:"media_name",show_control: false,sort_:85,sticky_control: true, text_right: false,},
				{title:"书城",width:100, sort_status:0,type:"channel_name",show_control: false,sort_:84,sticky_control: true, text_right: false,},
				{title:"公众号/点众渠道号",width:150, sort_status:0,type:"gzh_name",show_control: false,sort_:83,sticky_control: true, text_right: false,},
				{title:"投放小组",width:120, sort_status:0,type:"group_name",show_control: false,sort_:83,sticky_control: true, text_right: false,},
				{title:"小程序",width:90, sort_status:0,type:"applets_name",show_control: false,sort_:83,sticky_control: true, text_right: false,},
				
				{title:"投放金额(元)",width:110, sort_status:0,type:"put_money",show_control: true,sort_:39,sticky_control: false, text_right: true,},
				{title:"净投放金额(返点后)",width:150, sort_status:0,type:"used_money",show_control: true,sort_:38,sticky_control: false, text_right: true,},
				{title:"充值金额(元)",width:110, sort_status:0,type:"total_charge_money",show_control: true,sort_:37,sticky_control: false, text_right: true,},
				{title:"分成金额(元)",width:110, sort_status:0,type:"left_money",show_control: true,sort_:36,sticky_control: false, text_right: true,},
				{title:"总ROI",width:90, sort_status:0,type:"roi",show_control: true,sort_:35,sticky_control: false, text_right: true,},
				{title:"首日ROI",width:90, sort_status:0,type:"today_roi",show_control: true,sort_:34,sticky_control: false, text_right: true,},
				{title:"近7日ROI",width:100, sort_status:0,type:"recent_left_money",show_control: true,sort_:33,sticky_control: false, text_right: true,},
				{title:"粉丝数",width:90, sort_status:0,type:"sub_num",show_control: true,sort_:32,sticky_control: false, text_right: true,},
				{title:"粉丝成本",width:90, sort_status:0,type:"sub_num_price",show_control: true,sort_:31,sticky_control: false, text_right: true,},
				{title:"付费人数",width:90, sort_status:0,type:"pay_user_num",show_control: true,sort_:30,sticky_control: false, text_right: true,},
				{title:"付费成本",width:100, sort_status:0,type:"pay_cost",show_control: true,sort_:29,sticky_control: false, text_right: true,},
				{title:"当天付费人数",width:120, sort_status:0,type:"today_pay_user_num",show_control: true,sort_:28,sticky_control: false, text_right: true,},
				{title:"当天付费成本(元)",width:135, sort_status:0,type:"today_pay_user_num_cost",show_control: true,sort_:27,sticky_control: false, text_right: true,},
				{title:"ROI_前7天",width:100, sort_status:0,type:"recent_left_money_roi_before_7",show_control: true,sort_:26,sticky_control: false, text_right: true,},
				{title:"ROI_前6天",width:100, sort_status:0,type:"recent_left_money_roi_before_6",show_control: true,sort_:25,sticky_control: false, text_right: true,},
				{title:"ROI_前5天",width:100, sort_status:0,type:"recent_left_money_roi_before_5",show_control: true,sort_:24,sticky_control: false, text_right: true,},
				{title:"ROI_前4天",width:100, sort_status:0,type:"recent_left_money_roi_before_4",show_control: true,sort_:23,sticky_control: false, text_right: true,},
				{title:"ROI_前3天",width:100, sort_status:0,type:"recent_left_money_roi_before_3",show_control: true,sort_:22,sticky_control: false, text_right: true,},
				{title:"ROI_前2天",width:100, sort_status:0,type:"recent_left_money_roi_before_2",show_control: true,sort_:21,sticky_control: false, text_right: true,},
				{title:"ROI_前1天",width:100, sort_status:0,type:"recent_left_money_roi_before_1",show_control: true,sort_:20,sticky_control: false, text_right: true,},
				{title:"分成金额_前7天",width:130, sort_status:0,type:"recent_left_money_before_7",show_control: false,sort_:19,sticky_control: false, text_right: true,},
				{title:"分成金额_前6天",width:130, sort_status:0,type:"recent_left_money_before_6",show_control: false,sort_:18,sticky_control: false, text_right: true,},
				{title:"分成金额_前5天",width:130, sort_status:0,type:"recent_left_money_before_5",show_control: false,sort_:17,sticky_control: false, text_right: true,},
				{title:"分成金额_前4天",width:130, sort_status:0,type:"recent_left_money_before_4",show_control: false,sort_:16,sticky_control: false, text_right: true,},
				{title:"分成金额_前3天",width:130, sort_status:0,type:"recent_left_money_before_3",show_control: false,sort_:15,sticky_control: false, text_right: true,},
				{title:"分成金额_前2天",width:130, sort_status:0,type:"recent_left_money_before_2",show_control: false,sort_:14,sticky_control: false, text_right: true,},
				{title:"分成金额_前1天",width:130, sort_status:0,type:"recent_left_money_before_1",show_control: false,sort_:13,sticky_control: false, text_right: true,},
				
				
			],
			// 这个这得为数组，不能是字符串，因为是字符串的话，匹配不准
			zz_string:["date_key","op_name","book_name","book_type","platform_name","media_name","channel_name","gzh_name","group_name","applets_name","put_money","used_money","total_charge_money","left_money","roi","today_roi","recent_left_money","sub_num","sub_num_price","pay_user_num","pay_cost","today_pay_user_num","today_pay_user_num_cost","recent_left_money_before_1","recent_left_money_before_2","recent_left_money_before_3","recent_left_money_before_4","recent_left_money_before_5","recent_left_money_before_6","recent_left_money_before_7","recent_left_money_roi_before_1","recent_left_money_roi_before_2","recent_left_money_roi_before_3","recent_left_money_roi_before_4","recent_left_money_roi_before_5","recent_left_money_roi_before_6","recent_left_money_roi_before_7"], // 用于判断/过滤
			date_type_control: 'day', // 日期的控制，是展示日、月还是周
			r_page: 1, // 页数
			r_limit: 100, // 每页多少条
			table_total: 0, // 表格内容总数
			
			role_control: [], // 用户权限控制
			
		};
	},
	mounted(){
		let that = this
		this.search_button_loading = true
		that.filter_box_width = document.body.clientWidth // 筛选条件大盒子的宽度
		that.table_scroll_width = document.body.scrollWidth - 30 // 获取表格内容的宽度
		// console.log('document.body.clientWidth',that.filter_box_width,that.table_scroll_width)
		
		// 获取小程序下拉
		this.$refs.getXcxSelect.getSelectData()
		
		putDataMenu().then((res)=>{
			// console.log("putDataMenu",res.data.data.filter)
			that.filterData = res.data.data.filter
			// try{ // 正常执行的代码
			// 	console.log("正常执行的代码");
			// 	that.$refs.getGzhSelect.getSelectData(that.filterData.gzh_id.list || [])
				
			// 	that.$refs.getPutBook.getSelectData(that.filterData.book_id.list || [])
			// }catch(err){ // 如果出错，抛出错误
			// 	// 处理错误
			// 	console.log("处理错误",err);
				
			// 	that.$refs.getGzhSelect.getSelectData([])
				
			// 	that.$refs.getPutBook.getSelectData([])
			// }
			
			// 如果 数据录入状态 项，有下拉内容，则默认值要改为 已录入
			console.log("has_record",Object.keys(that.filterData.has_record))
			if(that.filterData.hasOwnProperty('has_record') && Object.keys(that.filterData.has_record).length > 0){ 
				that.r_has_record = 1
			}
			
			that.$nextTick(()=>{
				try{
					that.$refs.getGzhSelect.getSelectData(that.filterData.gzh_id.list || [])
				}catch(e){
					that.$refs.getGzhSelect.getSelectData([])
				}
				try{
					that.$refs.getPutBook.getSelectData(that.filterData.book_id.list || [])
				}catch(e){
					that.$refs.getGzhSelect.getSelectData([])
				}
			})
			
			// 获取29天前日期
			that.startTime = this.$getBeforeDay(29)
			// that.startTime = this.$getThisDay()
			// 获取当前日期
			that.endTime = this.$getThisDay()
			
			// 获取角色权限
			// that.role_control = JSON.parse(localStorage.getItem("role_limits"))
			
			// 搜索
			that.searchButton()
		})
		.catch(err=>{
			// this.search_button_loading = false
		})
		
		putDataPlatform({limit:1000,page:1}).then((res)=>{
			console.log("获取投放数据看板-筛选条件-媒体平台",res.data.data.data)
			that.filterPlatform = res.data.data.data || []
			// this.search_button_loading = false
		})
		.catch(err=>{
			// this.search_button_loading = false
		})
		
		
		
	},
	methods: {
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 日期范围控制，根据权限来
		DateControl(current){
			return current && current > moment().endOf('day') || current < moment().subtract(90, 'day');
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		// 投手
		handleChangeA(value) {
			console.log(value)
			this.r_op_id = value // 记录选择的人的id
		},
		
		// 投放作品
		handleChangeB(value) {
			this.r_put_book = value
		},
		
		// 作品类型
		handleChangeC(value) {
			this.r_book_type = value
		},
		
		// 媒体平台
		handleChangeD(value) {
			this.r_platform_id = value
		},
		
		// 媒体版位
		handleChangeE(value) {
			this.r_media_id = value
		},
		
		// 书城
		handleChangeF(value) {
			this.r_channel_id = value
		},
		
		// 公众号
		handleChangeGzh(value) {
			this.r_gzh_id = value
		},
		// 投手小组
		handleChangeT(value){
			this.r_group_id = value
		},
		// 汇总条件
		handleChangeHZ(e,index){
			this.collectHeadLabel[index].checked_status = e.target.checked
			console.log(`checked = ${e.target.checked}`);
		},
		// 汇总条件-投放日期
		onChangeHA(e) {
		  console.log(`checked = ${e.target.checked}`);
		},
		handleChangeH(value) { // 这个有用到，不要删
		    console.log(`selected ${value}`);
			this.r_date_type = value
		},
		handleChangeL(e){ // 数据录入
			// console.log("数据录入",e)
			this.r_has_record = e
		},

		
		// 数据项————————
		onChangeSJ(e,index){
			this.tableThLabel[index].checked_status = e.target.checked
			console.log(`checked = ${e.target.checked} + ${index}`);
		},
		
		// 选择小程序
		handleChangeXCX(e){
			this.r_appid = e
		},
		
		// 搜索按钮。class_是指排序方式desc或asc。type_是指要排序的表头。button_type表示按钮的操作类型，比如分页的搜索
		searchButton(class_,type_,button_type){
			let that = this
			// console.log()
			if(that.collectHeadLabel.findIndex(target=>target.checked_status === true) === -1){
				this.$warning({
					title: '警告',
					content: '请至少选择一个汇总条件',
				});
			}
			else if(that.tableThLabel.findIndex(target=>target.checked_status === true) === -1){
				this.$warning({
					title: '警告',
					content: '请至少选择一个数据项',
				});
			}
			else if(!that.startTime || !that.endTime){
				this.$warning({
					title: '警告',
					content: '请选择日期范围',
				});
			}
			else {
				
			if(button_type != '分页'){
				that.r_page = 1
			}
			
			this.search_button_loading = true
			
			let r_data = {
				start_time : that.startTime.replace(/-/g, ''),
				end_time : that.endTime.replace(/-/g, ''),
				put_book: that.r_put_book,
				// book_type: that.r_book_type,
				platform_id: that.r_platform_id,
				media_id: that.r_media_id,
				channel_id: that.r_channel_id,
				gzh_id: that.r_gzh_id,
				group_id: that.r_group_id,
				
				page: that.r_page,
				limit: that.r_limit,
				
				has_record: that.r_has_record, // 数据录入状态
				
				appid: that.r_appid,
			}
			if(that.r_book_type){
				r_data.book_type = that.r_book_type
			}
			
			
			// 超级管理、投放管理才有投手
			// if(that.role_control.includes(1) || that.role_control.includes(3)){
			// 	r_data.op_id = that.r_op_id
			// }
			// 有op_id字段，则表示有投手搜索条件
			if(Object.keys(that.filterData.op_id).length > 0){
				r_data.op_id = that.r_op_id
			}
			
			// r_data.start_time = that.startTime.replace(/-/g, '')
			// r_data.endTime = that.endTime.replace(/-/g, '')
			
			// let request_string = "start_time=" + that.startTime.replace(/-/g, '') + '&end_time=' + that.endTime.replace(/-/g, '')
			// console.log("request_string",this.request_string)
			// console.log("搜索条件：投手id",this.r_op_id) // 搜索条件：投手id
			// console.log("搜索条件：书籍",this.r_put_book) // 搜索条件：书籍
			// console.log("搜索条件：书籍类型id",this.r_book_type) // 搜索条件：书籍类型，1=男频，2=女频，0是全部，全部的情况好像可以不发送
			// console.log("搜索条件：媒体平台id",this.r_platform_id) // 媒体平台
			// console.log("搜索条件：媒体版位id",this.r_media_id) // 媒体版位
			// console.log("搜索条件：书城",this.r_channel_id) //  书城
			// console.log("搜索条件：公众号",this.r_gzh_id) // 公众号
			
			
			// console.log("搜索条件：数据项",this.tableThLabel) // 数据项
			// console.log("搜索条件：数据项",this.collectHeadLabel) // 汇总条件
			let r_group_by = '',r_order_by = ''
			
			that.collectHeadLabel.forEach((res,index)=>{
				if(res.checked_status){
					r_group_by = r_group_by + res.type + ","
				}
			})
			// console.log("r_group_by",r_group_by)
			// console.log("r_order_by",r_order_by)
			// console.log("class_",class_)
			if(class_ === 'desc'){
				// console.log("class_1",class_)
				
				r_data.order_by = type_ + " desc" 
			}
			else if(class_ === 'asc'){
				// console.log("class_2",class_)
				r_data.order_by = type_ + " asc" 
			}
			else {
				// console.log("class_3",class_)
				that.collectHeadLabel.forEach((res,index)=>{
					if(res.checked_status){
						r_order_by = r_order_by + res.type + " desc,"
					}
				})
				r_data.order_by = r_order_by.slice(0,-1)
			}
			
			r_data.group_by = r_group_by.slice(0,-1)
			
			
			// 表格的 投放日期 排序，在投放日期为 周 和 月 时，要进行特殊处理
			if(type_ == 'date_key' && that.r_date_type == 'month' && class_ == 'desc'){
				r_data.order_by = "YEAR(put_data.date_key) DESC,MONTH(put_data.date_key) DESC"
				// r_data.group_by = ""
			}
			else if(type_ == 'date_key' && that.r_date_type == 'month' && class_ == 'asc'){
				r_data.order_by = "YEAR(put_data.date_key) ASC,MONTH(put_data.date_key) ASC"
				// r_data.group_by = ""
			}
			else if(that.r_date_type == 'month' && !type_){ // 默认状态下不排序，也是这个值
				r_data.order_by = "YEAR(put_data.date_key) DESC,MONTH(put_data.date_key) DESC"
			}
			// 周 维度的先注释
			// if(type_ == 'date_key' && that.r_date_type == 'week' && class_ == 'desc'){
			// 	r_data.order_by = "YEARWEEK(put_data.date_key,1) desc"
			// }
			// else if(type_ == 'date_key' && that.r_date_type == 'week' && class_ == 'asc'){
			// 	r_data.order_by = "YEARWEEK(put_data.date_key,1) asc"
			// }
			
			// console.log("投放日期",this.filterData.time_type.list)
			if(this.collectHeadLabel[0].checked_status){ // 表示选中
				r_data.date_type = that.r_date_type
			}
			else { // 未选中默认传day
				r_data.date_type = "day"
			}
			
			let r_field = ""
			this.tableThLabel.forEach((res,index)=>{
				if(res.checked_status){
					if(res.label == "首日ROI"){
						r_field = r_field + res.type + "," + "today_left_money,"
					}
					else {
						r_field = r_field + res.type + ","
					}
					
				}
			})
			r_data.field = r_field.slice(0,-1)
			
			// console.log("r_data",r_data)
			
			// console.log("that.collectHeadLabel",that.collectHeadLabel)
			
			
			that.rableTitle.forEach((res_z,index_z)=>{
				// 控制哪些表头不用显示
				that.tableThLabel.forEach((res,index)=>{
					if(res_z.type === res.type){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_1'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_2'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_3'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_4'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_5'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_6'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_7'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_1'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_2'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_3'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_4'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_5'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_6'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_7'){
						res_z.show_control = res.checked_status
					}
				})
				
				// 固定列的处理
				that.collectHeadLabel.forEach((res_c,index_c) =>{
					if(res_c.label === '投手' && res_z.type === 'op_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '投放日期' && res_z.type === 'date_key'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '投放作品' && (res_z.type === 'book_name' || res_z.type === 'book_type')){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '媒体平台' && res_z.type === 'platform_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '媒体版位' && res_z.type === 'media_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '书城' && res_z.type === 'channel_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '公众号/点众渠道号' && res_z.type === 'gzh_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '投放小组' && res_z.type === 'group_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '小程序' && res_z.type === 'applets_name'){
						res_z.show_control = res_c.checked_status
					}
				})
			})
			
			
			
			// console.log("that.rableTitle",that.rableTitle)
			if(button_type != '导出'){
				
			
				putDataGetChargeSum(r_data).then(res=>{
					// console.log("搜索结果",res.data.data)
					// console.log("走这里",res.data.data.data.length)
					// console.log("走这里",res.data.data.sum.length)
					that.table_total = res.data.data.total
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						
						if(res.data.data.data.length === 0 && res.data.data.sum.length === 0){
							that.tableTotalData = []
							that.tableShowData = []
							that.search_button_loading = false
						}
						else {
							// console.log("走这里111")
							
							let req_data = JSON.parse(JSON.stringify(res.data.data))
							// console.log("req_data",req_data)
							// 把返回来的数据处理成表格上展现的。加上排序，宽度，内容等信息
							function handleData(sum_data){
								let total_key = Object.keys(sum_data)
								// console.log("total_key",total_key)
								let total_arry = []
								total_key.forEach((res,index) => {
									
									if(that.zz_string.indexOf(res) > -1){ // 过滤，只放表格需要的内容
										let obj = {
											value: sum_data[res],
											keys: res,
										}
										
										that.rableTitle.forEach((res_z,index_z) =>{
											
											if(res === res_z.type){
												
												obj.text_right = res_z.text_right
												// console.log("res",res)
												// console.log("res_z.type",res_z.type)
												// console.log(res === res_z.type)
												obj.widths = res_z.width // 加上宽度
												obj.sort_ = res_z.sort_ // 加上排序值，用来排序
												obj.show_control = res_z.show_control // 控制单元格是否显示
											}
											// 发现下面的代码不会执行，所以这里注释2022-8-17
											// else if(res.indexOf('recent_left_money_before') > -1 && res_z.type === 'recent_left_money_before'){
											// 	console.log(1111111111111)
											// 	obj.text_right = res_z.text_right
											// 	obj.widths = res_z.width // 加上宽度
											// 	obj.sort_ = res_z.sort_ // 加上排序值，用来排序
											// 	obj.show_control = res_z.show_control // 控制单元格是否显示
											// }
											// else if(res.indexOf('recent_left_money_roi_before') > -1 && res_z.type === 'recent_left_money_roi_before'){
											// 	console.log(22222222222222)
											// 	obj.text_right = res_z.text_right
											// 	obj.widths = res_z.width // 加上宽度
											// 	obj.sort_ = res_z.sort_ // 加上排序值，用来排序
											// 	obj.show_control = res_z.show_control // 控制单元格是否显示
											// }
										})
										total_arry.push(obj)
									}
								})
								
								return total_arry
							}
							
							// 总计那一行的处理
							// 后端返回的sum字段里没有这些键名，需要自己加
							let z_data = req_data.sum
							let z_data_key = Object.keys(req_data.sum)
							that.collectHeadLabel.forEach((res,index)=>{
								if(res.checked_status && res.label === '投放日期'){
									if(z_data_key.indexOf('z_data_key') < 0){
										z_data.date_key = " "
									}
								}
								else if(res.checked_status && res.label === '投手'){
									z_data.op_name = " "
								}
								else if(res.checked_status && res.label === '投放作品'){
									z_data.book_name = " "
									z_data.book_type = " "
								}
								else if(res.checked_status && res.label === '媒体平台'){
									z_data.platform_name = " "
								}
								else if(res.checked_status && res.label === '媒体版位'){
									z_data.media_name = " "
								}
								else if(res.checked_status && res.label === '书城'){
									z_data.channel_name = " "
								}
								else if(res.checked_status && res.label === '公众号/点众渠道号'){
									z_data.gzh_name = " "
								}
								else if(res.checked_status && res.label === '投放小组'){
									z_data.group_name = " "
								}
								else if(res.checked_status && res.label === '小程序'){
									z_data.applets_name = " "
								}
							})
							// console.log("z_data",z_data)
							let total_arry = handleData(z_data)
							total_arry.sort((a,b)=>{ // 从大到小排序
								return b.sort_ - a.sort_
							})
							// total_arry.unshift({
							// 	widths: 110, // 单元格宽度
							// 	value: "总计", // 内容
							// 	sort_: 110, // 排序值
							// 	show_control: true, // 内容是否显示
							// 	keys: "date_key", // 转换前的属性名
							// 	sticky_control: true, // 是否固定列
							// })
							that.tableTotalData = total_arry
							// console.log("that.tableTotalData",that.tableTotalData)
							// 总计那一行处理结束
							
							// 表格内容处理开始
							let show_data = req_data.data
							let show_arry = []
							// console.log('handleData(res)',show_data)
							show_data.forEach((res,index)=>{
								// 后端返回的表格数据有的字段根本就没有返回，我要自己加上
								if(!res.hasOwnProperty('date_key')){
									res.date_key = ' '
								}
								if(!res.hasOwnProperty('op_name')){
									res.op_name = ' '
								}
								if(!res.hasOwnProperty('book_name')){
									res.book_name = ' '
								}
								if(!res.hasOwnProperty('book_type')){
									// res.book_type = ' '
									this.$set(res,'book_type',' ')
								}
								if(!res.hasOwnProperty('platform_name')){
									res.platform_name = ' '
								}
								if(!res.hasOwnProperty('media_name')){
									res.media_name = ' '
								}
								if(!res.hasOwnProperty('channel_name')){
									res.channel_name = ' '
								}
								if(!res.hasOwnProperty('gzh_name')){
									res.gzh_name = ' '
								}
								if(!res.hasOwnProperty('group_name')){
									res.group_name = ' '
								}
								if(!res.hasOwnProperty('applets_name')){
									res.applets_name = ' '
								}
								// console.log("res.hasOwnProperty('book_type')",res.hasOwnProperty('book_type'))
								// console.log("resssss",res)
								// console.log(handleData(res))
								let s_data = handleData(res).sort((a,b)=>{ // 从大到小排序
									return b.sort_ - a.sort_
								})
								
								show_arry.push(s_data)
							})
							console.log("show_arry",show_arry)
							that.tableShowData = show_arry
							
							// console.log("document.getElementById('table-show-box').offsetWidth",document.body.scrollWidth)
							// that.table_scroll_width = document.body.scrollWidth
							// that.table_scroll_width = document.getElementById("table-show-box").offsetWidth
							
							
						}
						
						// 根据展示内容的不同，要对内容宽度进行处理
						let nnn = 30 // 边距
						that.rableTitle.forEach((res,index)=>{
							if(res.show_control){
								nnn += res.width
							}
						})
						that.table_scroll_width = nnn 
						// console.log("nnn",nnn)
						
						that.date_type_control = that.r_date_type
						
						that.search_button_loading = false
						that.$message.success('搜索成功');
					}
					else {
						that.search_button_loading = false
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
				.catch(err=>{
					that.$message.error('搜索请求错误，可能是网络不佳');
					that.search_button_loading = false
				})
			}
			else if(button_type == '导出'){
				r_data.report = 1
				delete r_data.page
				delete r_data.limit
				putDataExport(r_data).then(res=>{
					console.log("导出测试",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
					}
				})
			}
			
			}
		},
		// 导出按钮
		exportButton(e){
			let that = this
			that.searchButton('','','导出')
			
			// 	let r_url = ""
				
			// 	// 超级管理、投放管理才有投手
			// 	if(that.role_control.includes(1) || that.role_control.includes(3)){
			// 		r_url = `${that.$http.excel_url}api/down/put-stats-report?start_date=${that.startTime.replace(/-/g, '')}&end_date=${that.endTime.replace(/-/g, '')}&op_id=${that.r_op_id}&put_book=${that.r_put_book}&book_type=${that.r_book_type}&platform_id=${that.r_platform_id}&media_id=${that.r_media_id}&channel_id=${that.r_channel_id}&gzh_id=${that.r_gzh_id}&excel_type=1`
			// 	}
			// 	else {
			// 		r_url = `${that.$http.excel_url}api/down/put-stats-report?start_date=${that.startTime.replace(/-/g, '')}&end_date=${that.endTime.replace(/-/g, '')}&put_book=${that.r_put_book}&book_type=${that.r_book_type}&platform_id=${that.r_platform_id}&media_id=${that.r_media_id}&channel_id=${that.r_channel_id}&gzh_id=${that.r_gzh_id}&excel_type=1`
			// 	}
			
			// 	// window.open(r_url);
			// }
		},
		// 点击表格的表头排序
		tableThClick(index,status,type){
			let that = this
			// console.log("点击表格的表头排序",index)
			// console.log("点击表格的表头排序",status)
			console.log("点击表格的type",type)
			let ttt = type
			if(type == "recent_left_money"){
				ttt = "recent_left_money_roi"
			}
			
			if(status === 1){ // desc排序，箭头向下
				console.log('desc排序，箭头向下')
				that.searchButton('desc',ttt)
			}
			else if(status === 2){ // asc排序，箭头向上
				console.log('asc排序，箭头向上')
				that.searchButton('asc',ttt)
			}
			else { // 默认
				that.searchButton()
			}
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton('','','分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
	},
	
}
</script>

<style scoped>

.class-title {
	font-size: 16px;
	margin-bottom: 10px;
	text-align: left;
}

.loading-box {
	position: fixed;
	width: 100%;
	height: 100vh;
	left: 0;
	top: 0;
	z-index: 111;
	text-align: center;
	line-height: 100vh;
}
</style>